import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../lib/shared/validators";

export const validatorBoxType = v.object({
  name: v.string(),
  displayLabel: v.string(),
  standardLength: v.number(),
  standardWidth: v.number(),
  standardHeight: v.number(),
  standardVolumeCF: v.number(),
  basePrice: v.number(),
  displayOrder: v.number(),
  isActive: v.boolean(),
  color: v.optional(v.string()),
  internalControl: internalControl,
});

export const box_types = defineTable(validatorBoxType)
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_branch_id", ["internalControl.branchId"])
  .index("by_state", ["internalControl.state"])
  .index("by_company_and_state", [
    "internalControl.companyId",
    "internalControl.state",
  ])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ])
  .index("by_branch_and_state", [
    "internalControl.branchId",
    "internalControl.state",
  ])
  .index("by_created_by", ["internalControl.createdBy"])
  .index("by_updated_by", ["internalControl.updatedBy"])
  .index("by_created_at", ["internalControl.createdAt"])
  .index("by_company_and_created_at", [
    "internalControl.companyId",
    "internalControl.createdAt",
  ])
  .index("by_display_order", ["displayOrder"])
  .index("by_is_active", ["isActive"])
  .index("by_company_and_active", ["internalControl.companyId", "isActive"])
  .index("by_company_and_display_order", [
    "internalControl.companyId",
    "displayOrder",
  ])
  .searchIndex("search_box_types", {
    searchField: "name",
    filterFields: [
      "internalControl.companyId",
      "internalControl.state",
      "isActive",
    ],
  });
